<template>
  <div class="login-main wallet-main">
    <nav-bar></nav-bar>
    <section class="signup-start-main wallet-main header-top pb-0">
      <div
        class="review-container login-container review-main text-capitalize position-relative"
      >
        <lottie-animation
          ref="anim"
          :animationData="require('@/assets/animation.json')"
          class="animationCls"
          v-if="isAnimation"
        />
        <div class="row">
          <div class="col-md-12">
            <div class="sign-main wallet_main">
              <div class="wallet-top">
                <h4 class="mb-4">{{ $t("My Wallet") }}</h4>
              </div>
              <div class="mybal d-flex mb-2">
                <div>
                  <p class="mb-0">
                    <span>{{ $t("My Balance") }}</span>
                  </p>
                  <p class="amount mb-0">
                    <span
                      v-html="$auth.setting.currency"
                      class="currency"
                    ></span
                    >{{ Number(walletAmount).toFixed(1) ?? 0 }}
                  </p>
                </div>
                <div>
                  <div class="btn full-btn">
                    <a
                      href="javascript:void(0)"
                      @click="redeemModalFun()"
                      class="back-btn btn"
                      >Add Gift Card</a
                    >
                  </div>
                </div>
              </div>

              <!-- <div class="btn full-btn" v-if="$auth.setting.wallet_status == 'active' && $auth.user.wallet_status == 'active' && $auth.setting.wallet_status == 'active' && $auth.setting.wallet_recharge == 'active' ">                
                <router-link :to="{name:'wallet-payment'}" class="back-btn btn">{{$t('Add Money')}}</router-link>                
              </div> -->
            </div>
          </div>
          <div class="col-md-12 mt-2 plr15 trans-sec">
            <span class="trans-heading">{{ $t("Transactions") }}</span>
            <div class="wlt-ordr-list mt-5" v-if="isSkeletonLoader">
              <div class="wallet-detail w-100">
                <p>
                  <skeleton-loader-vue
                    type="string"
                    width="24%"
                    height="20px"
                  />
                </p>
                <p>
                  <skeleton-loader-vue
                    type="string"
                    width="30%"
                    height="20px"
                  />
                </p>
                <p class="wlt-date">
                  <skeleton-loader-vue
                    type="string"
                    width="24%"
                    height="20px"
                  />
                </p>
              </div>
              <div class="waltet-deduct">
                <skeleton-loader-vue type="string" width="15%" height="20px" />
              </div>
            </div>

            <div
              class="wlt-ordr-list mt-5"
              v-for="(history, key) in historys"
              :key="key"
            >
              <div class="wallet-detail w-100">
                <!-- <p v-if="history.note ==''">{{$t('Transaction ID #')}}<span>{{history.order_id}}</span></p> -->
                <p
                  v-if="
                    (history.type == 'refund' ||
                      history.type == 'spent' ||
                      history.type == 'cashback') &&
                    history.note == ''
                  "
                >
                  {{ $t(history.type)
                  }}<span v-if="history.user_order_id > 0"
                    >(Order #{{ history.user_order_id }})</span
                  >
                </p>
                <p
                  class="note-txt"
                  v-else-if="
                    history.note != '' &&
                    (history.type == 'refund' ||
                      history.type == 'spent' ||
                      history.type == 'cashback' ||
                      history.type == 'recharge')
                  "
                >
                  {{ history.note }}
                </p>
                <p v-else>{{ $t(history.type) }}</p>
                <p class="wlt-date">
                  {{ moment(history.order_date).format("DD-MMM YYYY hh:mm A") }}
                </p>
              </div>
              <div class="waltet-deduct">
                <p
                  class="deduct-prc clr-red"
                  v-if="['spent'].includes(history.type)"
                  :class="history.type"
                >
                  -<span v-html="$auth.setting.currency" class="currency"></span
                  >{{ history.amount }}
                </p>
                <p class="deduct-prc clr-grn" v-else>
                  +<span v-html="$auth.setting.currency" class="currency"></span
                  >{{ history.amount }}
                </p>
              </div>
            </div>
            <div
              v-if="historys.length == 0 && !isSkeletonLoader"
              class="no-tranc"
            >
              <p>{{ $t("No Transactions Found") }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-------chowmnpay Redeem Modal------->
    <div
      class="modal fade redeemModal-modal"
      id="redeemModal"
      tabindex="-1"
      aria-labelledby="redeemModallabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content location-modal">
          <div class="modal-header">
            <h4 class="modal-title" id="filterLabel"></h4>
            <a
              data-dismiss="modal"
              class="lnk"
              @click="isredeemModalOpen = false"
            >
              <!-- {{$t('Close')}} -->
              <svg
                fill="#000000"
                width="25px"
                height="25px"
                viewBox="0 0 32 32"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M16 0c-8.836 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 30.032c-7.72 0-14-6.312-14-14.032s6.28-14 14-14 14 6.28 14 14-6.28 14.032-14 14.032zM21.657 10.344c-0.39-0.39-1.023-0.39-1.414 0l-4.242 4.242-4.242-4.242c-0.39-0.39-1.024-0.39-1.415 0s-0.39 1.024 0 1.414l4.242 4.242-4.242 4.242c-0.39 0.39-0.39 1.024 0 1.414s1.024 0.39 1.415 0l4.242-4.242 4.242 4.242c0.39 0.39 1.023 0.39 1.414 0s0.39-1.024 0-1.414l-4.242-4.242 4.242-4.242c0.391-0.391 0.391-1.024 0-1.414z"
                  ></path>
                </g>
              </svg>
            </a>
          </div>
          <div class="modal-body">
            <h6 class="mb-2">Redeem Code</h6>
            <input
              type="text"
              class="form-control h50"
              placeholder="xxxx xxxx xxxx xxxx"
              v-model="giftCode"
            />
            <p class="clr-red">{{ error }}</p>
            <div class="delivery-address delivery-address-nw border-0 mt-4">
              <div class="full-btn" @click="setRedeemFun()">
                <a href="javascript:void(0)" class="red-outline-btn">{{
                  $t("Submit")
                }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-------chowmnpay Redeem Modal------->
    <Footer></Footer>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import NavBar from "@/components/NavBar.vue";
import Footer from "../components/Footer.vue";
import Wallet from "../apis/wallet";
import moment from "moment";
import VueSkeletonLoader from "skeleton-loader-vue";
import LottieAnimation from "lottie-web-vue";

export default {
  components: {
    NavBar,
    Footer,
    "skeleton-loader-vue": VueSkeletonLoader,
    LottieAnimation,
  },
  data() {
    return {
      historys: [],
      moment: moment,
      walletAmount: 0,
      isSkeletonLoader: true,
      isredeemModalOpen: false,
      giftCode: "",
      error: "",
      isAnimation: false,
      prevRoute: null,
    };
  },
  watch: {
    giftCode: function () {
      this.giftCode = this.cc_format(this.giftCode);
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },

  mounted() {
    if (
      localStorage.getItem("isAlertVoucherCard") == "true" &&
      this.prevRoute.name != null
    ) {
      this.redeemModalFun();
    }
    this.getWalletHistory();
  },

  methods: {
    ...mapActions("wallet", ["getUserWalletHistoryData"]),
    ...mapActions("promocode", ["giftVoucherRedeemData"]),

    getWalletHistory() {
      Wallet.gerUserWalletHistory({
        user_id: this.$auth.user.user_id,
        is_langauge: this.$store.state.lang.locale,
        vendor_id: this.$auth.getVendorId(),
      }).then((response) => {
        if (response.data.code == 200) {
          this.isSkeletonLoader = false;
          this.historys = response.data.Result;
          this.walletAmount = response.data.wallet_amount;
          this.isSkeletonLoader = false;
        } else {
          this.isSkeletonLoader = false;
          this.historys = [];
        }
      });
    },

    date_convert(date) {
      return this.$t(date.substring(0, 3)) + date.slice(3);
    },

    redeemModalFun() {
      this.error = "";
      this.giftCode = "";
      this.isredeemModalOpen = true;
      localStorage.removeItem("isAlertVoucherCard");
      $("#redeemModal").modal("show");
    },

    setRedeemFun() {
      if (this.giftCode) {
        this.giftVoucherRedeemData({
          gift_code: this.giftCode.split(" ").join(""),
        }).then((response) => {
          if (response.code == 200) {
            $("#redeemModal").modal("hide");
            //this.$toasted.success(response.msg, { duration: 1000 });
            this.isAnimation = true;
            this.$swal({
              icon: "success",
              showCloseButton: false,
              showConfirmButton: true,
              html: response.msg,
            }).then((result) => {
              window.location.reload();
            });
          } else {
            this.error = response.msg;
          }
        });
      } else {
        alert("Please Enter Gift Voucher");
      }
    },

    cc_format(value) {
      var v = value.replace(/\s+/g, "").replace(/[^a-z0-9]/gi, "");
      var matches = v.match(/[A-Za-z0-9]{4,16}/g);
      var match = (matches && matches[0]) || "";
      var parts = [];
      for (let i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4));
      }
      if (parts.length) {
        return parts.join(" ");
      } else {
        return value;
      }
    },
  },
};
</script>
